module.exports = __webpack_public_path__ + "img/home_banner1.40ca7d53.png";